import styled from 'styled-components';

export const Style = styled.div`
  .title.initial {
    display: flex;
    align-items: center;
    gap: 30px;

    h4 {
      color: #555555;
    }
  }

  h2 {
    font-size: 18px;
    font-weight: 600;
    color: #555;
  }
  h4 {
    font-size: 18px;
    font-weight: 500;
    color: #555;
  }

  .contentContainer {
    border-radius: 0;
  }
  .contentContainer:nth-child(1) {
    border-radius: 10px 10px 0 0;
  }
  .contentContainer:nth-child(3) {
    border-radius: 0 0 10px 10px;
  }

  .warningSign {
    margin-top: 8px;
  }

  .roomListWrap {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    gap: 20px;
  }

  /* roomListBox */
  .roomListBox {
    border-radius: 5px;

    .header {
      display: flex;
      justify-content: space-between;
      padding: 12px 24px;
      background: #ecf5f3;
      border: 1px solid #cecece;
      border-radius: 5px 5px 0 0;

      h2 {
        max-width: 350px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .content {
      margin-top: -1px;
      border: 1px solid #cecece;
      padding: 24px;
      border-radius: 0 0 5px 5px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;

      .textWrap {
        display: flex;
        flex-direction: column;
        gap: 20px;
        h4 {
          font-size: 16px;
          font-weight: 400;
          color: #555;
        }
        h5 {
          width: 80px;
          font-weight: 400;
          color: #555;
        }
      }

      .flex {
        gap: 16px;
      }
      button {
        height: 22px;
        padding: 0 4px;
        img {
          width: 22px;
          height: 22px;
        }
      }
    }

    .viewType {
      .toggleButton {
        width: 16px;
        padding: 2px 0;
      }
      .toggleButton.noTitle {
        padding: 8px 0;
      }
    }
  }

  .flex {
    display: flex;
    align-items: center;
    gap: 8px;

    p {
      font-size: 14px;
      font-weight: 300;
      color: #555;
    }
  }

  .numberBox {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
    min-height: 24px;
    border: 1px solid #4dd2ae;
    border-radius: 3px;
    margin-right: 6px;

    p {
      color: #40977f;
      font-weight: 500;
    }
  }

  .noneList {
    padding: 60px 0;
    text-align: center;
    h2 {
      color: #cecece;
      font-weight: 400;
    }
  }
  @media (max-width: 650px) {
    .roomListBox .header h2 {
      max-width: 300px;
    }
  }
  @media (max-width: 550px) {
    .roomListBox .header h2 {
      max-width: 220px;
    }
  }
  @media (max-width: 450px) {
    .roomListBox .header h2 {
      max-width: 120px;
    }
  }
`;
